import React from 'react'
import Topheader from '../../../Home/topHeader/Topheader'
import Middlebar from '../../../Home/middleBar/Middlebar'
import NavMenu from '../../../Home/navigationBar/NavMenu'
// import Navbar from '../../Home/navigationBar/Navbar'
import Footer from '../../../../components/Home/footer/Footer'
// import AccordionCard from './AccordionCard'
// import Accordian from '../accordion/Accordian'
import { Link } from "react-router-dom";
import AccordionCard from './AccordionCard'

export default function Mba1years () {
  return (
    <>
    <Topheader/>
    <Middlebar/>
    <NavMenu/>
    {/* <Navbar/> */}
      <div className="  bg-gray-200 items-center justify-center  ">
        <div className="banner">
            <img src='/MBA2.5.png' 
             alt='MBA 1 YEARS'
             className='w-full sm:w-[100%] md:w-[100%] lg:w-[100%]'/>
        </div>
        <div className="content bg-gray-200 2xl:w-[80%] xl:w-[90%] lg:w-[100%] md:w-[100%] sm:w-[100%] xs:w-[200%] justify-items-center m-auto">
          <div className="mx-28 2xl:w-[83%] xs:text-base">
               <h1 className='text-5xl font-bold mt-20 font-poppins text-red-800'>Course Detail</h1>

               <p className=" text-justify mt-4 mb-5 ">
               The MBA program at<strong> Emaan Institute of Management and Sciences (EIMS)</strong> is a rigorous two years Degree Program 
               encompassing numerous aspects of business and management, enabling students to attain core knowledge of 
               business concepts. The Program improves students’ ability to develop analytical and problem solving skills. 
               Courses are taught through innovative teaching methodologies such as case studies, action based learning and 
               research projects. Students are motivated to work in groups from day one, and trained to accept the challenges 
               of the real life situations.
               </p>

               <p className=" text-justify mt-2 mb-8 ">
               MBA after BBA 4 years (or equivalent 16 years business degree holders) is a MS/M.Phil level degree program 
               and comprises of 10 courses and a research project/Thesis (6 credit hours). The minimum program duration 
               will be 1.5 years; the maximum duration will be 4 years. Degree requirement for MBA Program is minimum 2.5 
               CGPA
               </p>
               
               {/* <h3 className=" font-semibold text-sm">BBA Students learn to</h3>
               <ul className='list-disc mx-7 mt-2 mb-3 text-sm'>
                 <li className='my-1'>Lorem ipsum dolor sit amet consectetur adipisicing elit. </li>
                 <li className='my-1'>Lorem ipsum dolor sit amet consectetur adipisicing elit. </li>
                 <li className='my-1'>Lorem ipsum dolor sit amet consectetur adipisicing elit. </li>
                 <li className='my-1'>Lorem ipsum dolor sit amet consectetur adipisicing elit. </li>
               </ul>

               <h3 className=" font-semibold text-base mt-5 ">Learning Outcomes for BBA Students include:</h3>
               <ol className='list-decimal mx-7 mt-2 text-sm mb-5'>
                 <li className='my-1'>Lorem ipsum dolor sit amet consectetur adipisicing elit. </li>
                 <li className='my-1'>Lorem ipsum dolor sit amet consectetur adipisicing elit. </li>
                 <li className='my-1'>Lorem ipsum dolor sit amet consectetur adipisicing elit. </li>
               </ol>*/}

               <h1 className="text-2xl font-bold mt-5 font-poppins text-red-800">Eligibility Criteria</h1>
               <p className='mt-2'>
                <li className='m-1'>Minimum 16 years of education from HEC recognized DAI/University</li>
                <li className='m-1'>Applicant must clear Admission/aptitude Test of EIMS or (GAT/HAT)</li>
                <li className='m-1'>Interview conducted by the institute</li>
                <li className='m-1'>Required credentials as per HEC policy</li>
                </p> 
          </div>
          <div className='mt-10 mb-10'>
            {/* <Accordian/> */}
            <AccordionCard/>      
            </div>
        <div  className=' '>
       <Link to="/ApplyNow"><button className="mx-28 w-80 h-14 rounded-md text-white bg-maroon  font-bold text-3xl">APPLYNOW</button></Link> 
      </div>
        </div>
        <div className=' pb-20 xl:ml-14'>

        </div>
      </div>
    <Footer/>  
    </>
  )
}
